import { createIconComponent } from '../../factory/create-icon-component';
export const MinimizeIcon = createIconComponent(
  'MinimizeIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 10H20M14 10L19 5M14 10V6.5V4M10 14H4M10 14L5 19M10 14V17.5V20"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
